/**
 * Canonical design tokens shared by web (MUI) and mobile (react-native-paper).
 * Keep palette aligned with apps/web/src/themes/appTheme.tsx.
 */

export const palette = {
  light: {
    primary: '#6366f1',
    primaryLight: '#a5b4fc',
    primaryDark: '#4338ca',
    secondary: '#ec4899',
    secondaryLight: '#f9a8d4',
    secondaryDark: '#be185d',
    background: '#e5e5e5',
    backgroundPaper: '#f5f5f5',
    /** Elevated surfaces (cards, sheets) — mobile cards */
    surface: '#ffffff',
    text: '#1f2937',
    textSecondary: '#6b7280',
    border: '#e2e8f0',
    error: '#ef4444',
    success: '#22c55e',
    warning: '#f59e0b',
    tint: '#6366f1',
    icon: '#64748b',
    tabIconDefault: '#94a3b8',
    tabIconSelected: '#6366f1',
  },
  dark: {
    primary: '#818cf8',
    primaryLight: '#c7d2fe',
    primaryDark: '#6366f1',
    secondary: '#f472b6',
    secondaryLight: '#fbbf24',
    secondaryDark: '#ec4899',
    background: '#0a0a17',
    backgroundPaper: '#131321',
    surface: '#1e293b',
    text: '#f9fafb',
    textSecondary: '#d1d5db',
    border: '#334155',
    error: '#f87171',
    success: '#4ade80',
    warning: '#fbbf24',
    tint: '#818cf8',
    icon: '#94a3b8',
    tabIconDefault: '#475569',
    tabIconSelected: '#818cf8',
  },
} as const;

export type PaletteMode = 'light' | 'dark';

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
} as const;

export const Radius = {
  sm: 6,
  md: 12,
  lg: 20,
  full: 9999,
} as const;

export const FontSize = {
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 22,
  '2xl': 28,
  '3xl': 36,
} as const;
